import React from "react";
import "./StudentNotificationDetail.css";

export const StudentNotificationDetailSkeleton = () => {
  return (
    <div className="notification-page">
      <div className="notification-detail-wrapper">
        <div className="notification-header">
          <div>
            <div className="skeleton skeleton-title"></div>
            <div className="skeleton skeleton-subtitle"></div>
          </div>
        </div>

        <div className="notification-detail-card skeleton-card">
          <div className="detail-top">
            <div>
              <div className="skeleton skeleton-heading"></div>
              <div className="skeleton skeleton-meta"></div>
            </div>
            <div className="skeleton skeleton-badge"></div>
          </div>

          <div className="skeleton skeleton-paragraph"></div>
          <div className="skeleton skeleton-paragraph short"></div>
        </div>
      </div>
    </div>
  );
};
